// extracted by mini-css-extract-plugin
export var asterisk = "CalculatorWithForm-module--asterisk--PMyGQ";
export var container = "CalculatorWithForm-module--container--T9HpF";
export var form = "CalculatorWithForm-module--form--ctr43";
export var head = "CalculatorWithForm-module--head--YzMjm";
export var section = "CalculatorWithForm-module--section--mpUGZ";
export var sliderContainer = "CalculatorWithForm-module--sliderContainer--HxdSK";
export var sliders = "CalculatorWithForm-module--sliders--Xlzex";
export var title = "CalculatorWithForm-module--title--5Jtnz";
export var wrapper = "CalculatorWithForm-module--wrapper---+4o8";